import { AppContext } from '../config/appConfig'

export const getAppContext = (): AppContext => {
    const context: string = new URLSearchParams(window.location.search).get('context')
    return Object.values(AppContext).find((value: AppContext) => value === context) || AppContext.None
}

export const isAppContext = (context: AppContext | AppContext[]): boolean =>
    (Array.isArray(context) ? context : [context]).includes(getAppContext())
